exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert[data-v-037a850e] {\n    margin-top: 1rem;\n}\n.alert[data-v-037a850e]:hover {\n    border: 1px solid transparent !important;\n}\n", ""]);

// exports
